import { TUploadedMedia } from '@/services'

import { imageUrlToFile } from './imageUrlToFile'

export const getFileFromMedia = (
	uploadedImage: TUploadedMedia,
): Promise<File> =>
	new Promise((resolve, reject) => {
		setTimeout(async () => {
			if (uploadedImage.publicId.length > 0) {
				const file = await imageUrlToFile(
					`${uploadedImage.bucketRootUrl}/${uploadedImage.publicId}`,
					uploadedImage.publicId,
					uploadedImage.resourceType,
				)
				resolve(file)
			}
			reject(
				new Error(`Could not get file for image ${uploadedImage.publicId}`),
			)
		}, 0)
	})
